export class LineChartOptions {
    yaxis: any = {
        tickColor: "#494949"
    };
    xaxis: any = {
        mode: "time"
        , timeformat: "%d/%m/\n%Y"

    };
    colors: any = ["#35c4e8", "#fbf05b", "#62c2a1"];
    series: any = {
        lines: {
            show: true,
            fill: true,
            fillColor: { colors: [{ opacity: 0 }, { opacity: 0.1 }] },
            lineWidth: 4
        },
        points: {
            show: true,
            lineWidth: 1,
            radius: 3,
            fill: true,
            fillColor: '#222a33'
        }
    };
    grid: any = {
        hoverable: true,
        clickable: true,
        borderWidth: 0
    };
    legendSelector: string = ".custom_legend";
    legend: any;
    height: number = 250;
    formatTooltip: string;
    roundTooltip: boolean = false;
    tooltipCurrency: string = '';
    tooltipSign: string = '';

    public getTooltipLeft(window: any): number {
        let leftOffset = 0;
        if ($(window).width() < 960) leftOffset = 15;
        if ($(window).width() >= 960 && $(window).width() < 1400) leftOffset = 15;
        if ($(window).width() >= 1400) leftOffset = 16;
        return leftOffset;
    }

    // Format is $0.00
    public getMonetaryShortFormat(val, axis): string {
        return "$" + Math.round(val.toFixed(2));
    }
}


// WEBPACK FOOTER //
// ./src/app/dashboard/chart/line-chart-options.model.ts